(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-abm-hp-tab]')];
    const select = (tab, focus) => {
      const key = tab.dataset.abmHpTab;
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      root.querySelectorAll('[data-abm-hp-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.abmHpPanel === key));
      root.querySelectorAll('[data-abm-hp-figure]').forEach((f) => f.classList.toggle('is-active', f.dataset.abmHpFigure === key));
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        select(tabs[(i + step + tabs.length) % tabs.length], true);
      });
    });
  };
  document.querySelectorAll('[data-abm-hp]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-abm-hp]')));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest('[data-abm-hp]');
    const panel = e.target.closest('[data-abm-hp-panel]');
    if (root && panel) root.querySelector(`[data-abm-hp-tab="${panel.dataset.abmHpPanel}"]`)?.click();
  });
})();
